"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CANCELLABLE_STATUSES = exports.ORDER_PROGRESS_STAGES = exports.PAYMENT_STATUS_LABELS = exports.ORDER_STATUS_LABELS = void 0;
// Status display helpers
exports.ORDER_STATUS_LABELS = {
    pending: 'Pending',
    confirmed: 'Confirmed',
    in_production: 'In Production',
    quality_check: 'Quality Check',
    shipped: 'Shipped',
    out_for_delivery: 'Out for Delivery',
    delivered: 'Delivered',
    cancelled: 'Cancelled',
    returned: 'Returned',
};
exports.PAYMENT_STATUS_LABELS = {
    pending: 'Pending',
    awaiting_payment: 'Awaiting Payment',
    paid: 'Paid',
    failed: 'Failed',
    refund_pending: 'Refund Pending',
    refunded: 'Refunded',
};
// Ordered stages for the timeline (excluding terminal states)
exports.ORDER_PROGRESS_STAGES = [
    'pending',
    'confirmed',
    'in_production',
    'quality_check',
    'shipped',
    'out_for_delivery',
    'delivered',
];
// Statuses that allow user cancellation
exports.CANCELLABLE_STATUSES = ['pending', 'confirmed'];
